export default "__VITE_ASSET__fLOotuNgYw2PWHBRROdq1A__"